<div class="nav-search d-block position-relative">
  <a class="mob-toggler" href="javascript:"
    ><i class="feather icon-more-vertical text-success"></i
  ></a>

  <div class="nav-search-box d-flex align-items-center gap-2">
    <i class="fa fa-search nav-search-box__icon"></i>

    <input
      #searchBar
      type="text"
      class="nav-search-box__input"
      [placeholder]="placeholder"
      (input)="search(searchBar.value)"
      [disabled]="isSubscriptionExpired"
    />
  </div>
</div>

<div *ngIf="searchOn && !isSyncInProcess">
  <app-nav-lookup-item
    [isNavbarCollapse]="isNavbarCollapse"
    [(searchOn)]="searchOn"
  ></app-nav-lookup-item>
</div>
